/**
 * Capability keys for Admin > Calibration Fixes, plus the roles that already
 * imply them.
 *
 * MIRRORS the server guard exactly — this only decides what to render; the
 * router-level `RequirePermission(CALIBRATION_REMEDIATION_KEYS,
 * ORG_DESTRUCTIVE_ROLES)` in calibration_remediation.py is the control.
 * Keep in step, in both directions: too narrow and someone who can use the tool
 * never sees the tab; too wide and they get a tab that 403s.
 */

/** Roles that imply the whole tool. Matches backend CALIBRATION_FIX_ROLES (HRBPs too: HR UAT list #26). */
export const CALIBRATION_REMEDIATION_ROLES = ['admin', 'hr_admin', 'hrbp'] as const

export const CALIBRATION_REMEDIATION_KEYS = [
  /** See the worklist — ratings and justifications, so HR-sensitive. */
  'calibration:remediate:read',
  /** Apply a fix. Phase 2; registered now so a grant needs no code change. */
  'calibration:remediate:write',
] as const
